export const ACCESSTOKEN_KEY = "jwt";
export const REFRESHTOKEN_KEY = "refresh";
export const API_HOST = (process.env.NODE_ENV === 'development')
                ? 'https://tstaffapi.redhotpie.com.au' 
                  //  'http://localhost:58077'
                : 'https://affsrvs.affiliatequarter.com'